// extracted by mini-css-extract-plugin
module.exports = {"social-links":"b49a62dc46--social-links--LQfWg","tg":"b49a62dc46--tg--V0fu4","ok":"b49a62dc46--ok--Cl9_2","vk":"b49a62dc46--vk--EM4gh","wh":"b49a62dc46--wh--RiL_x"};